import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
// import * as ReactDOM from 'react-dom';
import * as ReactDOM from 'react-dom/client';  // Import from 'react-dom/client'
import { Provider } from 'react-redux';

import { store } from "./app/store";
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from "react-router-dom";

// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
//const store = configureStore(history);

// ReactDOM.render(
//     <Provider store={store}>
//           <BrowserRouter>
//           <App />
//           </BrowserRouter>
           
       
//     </Provider>,
//     document.getElementById('root'));

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );

registerServiceWorker();
